/**
 * TanStack Query key factory — barcha query key'lar markazlashtirilgan.
 */
export const queryKeys = {
  tenants: (params = {}) => ['tenants', params],
  tenantDetail: (id) => ['tenants', id],
  warehouseOverview: (params = {}) => ['warehouse', 'overview', params],
  auditLogs: (params = {}) => ['audit', params],
  orders: (params = {}) => ['orders', params],
  products: (params = {}) => ['products', params],
  leads: (params = {}) => ['leads', params],
  integrations: () => ['integrations'],
  regions: () => ['regions'],
  districts: (regionId) => ['districts', regionId],
  businessTypes: () => ['businessTypes'],
  tariffs: () => ['tariffs'],
  statistics: (key) => ['statistics', key],
  /** Statistika sahifasi to‘liq bundle (role + filial + davr) — kesh kaliti */
  statisticsBundle: (params) => ['statistics', 'bundle', params],
  notifications: () => ['notifications'],
  reports: () => ['reports'],
  featureFlags: () => ['featureFlags'],
  user: () => ['user'],
};

/** window.dispatchEvent — kassa sotuvi serverga muvaffaqiyatli yozilganda moliya/statistikani yangilash */
export const POS_SALE_COMPLETED_EVENT = 'addesite-pos-sale-completed';

/** Ombor mahsulot tahriri — kassa mahsulotlar ro'yxatini yangilash */
export const PRODUCTS_INVALIDATED_EVENT = 'addesite-products-invalidated';
